import { type ReactNode } from 'react';
import Icon, { type IconName } from '../Icon';

// The look of every full-page state (EmptyState style, DESIGN.md). No router
// and no app modules on purpose: the bootstrap screens (LoadError,
// ConfigError) render it before, or instead of, the app.

interface StatusPageProps {
  icon: IconName;
  title: string;
  children: ReactNode;
  /** Announce it: for failures, not for a calm "not found". */
  alert?: boolean;
  actions?: ReactNode;
}

export default function StatusPage({
  icon,
  title,
  children,
  alert = false,
  actions
}: StatusPageProps): JSX.Element {
  return (
    <div
      role={alert ? 'alert' : undefined}
      className="flex flex-col items-center justify-center py-20 text-center"
    >
      <div className="mb-4 rounded-full bg-surface-subtle p-4 text-ink-muted">
        <Icon name={icon} size={32} />
      </div>
      <h1 className="section-title m-0">{title}</h1>
      <div className="m-0 mt-2 text-ink-muted">{children}</div>
      {actions !== undefined && (
        <div className="mt-6 flex gap-3">{actions}</div>
      )}
    </div>
  );
}
